<script>
import ContactEntry from './contact-entry.vue'
import ContactNavbar from './contact-navbar.vue'

export default {
  components: {ContactEntry, ContactNavbar},

  props: {
    userIds: {type: Array, default: null},
    talkContentCode: {type: String, default: null},
  },

  data() {
    return {
      filter: {},
      contacts: [],
      numContacts: 0,
      perPage: 60,
      numPages: 0,
      page: this.$route.query.page || 1,
      mmUserId: this.$storage.get('mm_user_id'),
      directChannels: [],
    }
  },

  watch: {
    filter: {
      handler(newValue) {
        this.page = 1
        this.fetchContacts(newValue)
        let query = this.filter.search ? {search: this.filter.search} : {}
        this.pushQuery(query)
      },
      deep: true
    },
    page: {
      handler(newValue) {
        this.fetchContacts(this.filter, newValue)
      },
    },
  },

  created() {
    if (this.$route.query.search) {
      this.filter.search = this.$route.query.search
    }
    if (this.userIds) {
      this.filter.mmid = this.userIds
    }
    if (this.talkContentCode) {
      this.filter.talk_code = this.talkContentCode
    }
    this.fetchContacts(this.filter, this.page)
  },

  methods: {
    pushQuery(query) {
      try {
        this.$router.push({query: query})
      } catch(error) {
        console.error(error)
      }
    },

    contactUrl(contact) {
      return `/community/${contact.mmid}`
    },

    onSearchChanged: function (search) {
        this.$set(this.filter, 'search', search)
    },

    previousPage: function() {
      if (this.page > 1) this.page--
      let query = this.filter
      if (this.page > 1) query.page = this.page
      this.$router.push({query: query})
    },

    nextPage: function() {
      if (this.page < this.numPages) this.page++
      let query = this.filter
      if (this.page > 1) query.page = this.page
      this.$router.push({query: query})
    },

    fetchImages() {
      let me = this
      for (const c of me.contacts) {
        me.$mattermost.get(`/users/${c.id}/image`, {responseType: 'arraybuffer'}).then(response => {
          const blob = new Blob([response.data], { type: 'image/png' });
          // Create a URL for the Blob
          me.$set(c, 'img_url',  URL.createObjectURL(blob))
        })
      }
    },

    fetchContacts: function (filter, page=1) {
      let me =  this
      let params = {page: page, ...this.filter}
      me.$api.get('/community-users/', {params:params}).then(function(response){
        if (me.mmUserId)
          me.contacts = response.data.results.filter(contact => contact.mmid !== me.mmUserId) || []
        else
          me.contacts = response.data.results
        me.numContacts = me.contacts.length
        me.numPages = response.data.pages
      })
    },
  },
}
</script>

<template>

  <div>
    <contact-navbar v-if="!userIds" class="mb-1"
      :search="filter.search || ''"
      @search="onSearchChanged($event)" 
      @delete-search="filter = {}" 
    />

    <div v-if="numContacts > 0">
      <small class="text-muted me-1">{{numContacts}} Treffer</small>

      <div class="list-group text-deco-none">
        <router-link v-for="contact in contacts" :key="contact.id" :to="contactUrl(contact)" class="text-deco-none">
          <contact-entry :contact="contact" />
        </router-link>
      </div>

      <div v-if="numPages > 1" class="py-3 text-center">
        <button :disabled="page == 1">
          <i class="fas fa-chevron-left" @click.prevent="previousPage()"></i>
        </button>
        <span class="mx-3">{{ page }} / {{ numPages }}</span>
        <button :disabled="page == numPages">
          <i class="fas fa-chevron-right" @click.prevent="nextPage()"></i>
        </button>
      </div>

    </div>
    <div v-else>
      <div class="text-center mt-5">-- keine Treffer --</div>
    </div>

  </div>
</template>

<style scoped>

button {
  border: none;
  background: none;
  cursor: pointer;
}

.text-deco-none {
  text-decoration: none;
}

</style>